import * as APP_CONFIG from "../constants/config";
import moment from "moment/moment";

const {DBDateFormat, DateDisplayFormat} = APP_CONFIG;

export const setPerformance = _items => {
    const items = [..._items];
    // totalen wp, cp alle items
    const totalWp = items.reduce((total, item) => total + item.wp, 0);
    const totalCp = items.reduce((total, item) => total + item.cp, 0);
    // totalen wp, cp items per locatie
    const groupedTotals = items.reduce((totals, i) => (
        {
            ...totals,
            [i.location]: totals[i.location] ?
                {
                    totalWp: totals[i.location].totalWp + i.wp,
                    totalCp: totals[i.location].totalCp + i.cp
                } :
                {totalWp: i.wp, totalCp: i.cp}
        }
    ), {});
    // bepaal performance en performance per locatie
    items.map(item => {
        // performance
        const wpPerc = totalWp > 0 ? item.wp / totalWp : 0;
        const cpPerc = totalCp > 0 ? item.cp / totalCp : 0;
        item.performance = wpPerc > 0 ? Math.abs((cpPerc / wpPerc) * 100) : 0;
        // grouped performance
        const groupedWpTotal = groupedTotals[item.location].totalWp;
        const groupedCpTotal = groupedTotals[item.location].totalCp;
        const wpPercLocation = groupedWpTotal > 0 ? item.wp / groupedWpTotal : 0;
        const cpPercLocation = groupedCpTotal > 0 ? item.cp / groupedCpTotal : 0;
        item.groupedPerformance = wpPercLocation > 0 ? Math.abs((cpPercLocation / wpPercLocation) * 100) : 0;
        return null;
    });
    return items;
}


export const fetchData = async url => {
    console.log(`fetchdata: ${url}`);
    let response, responsejson;
    try {
        response = await fetch(url);
        if (!response.ok)
            throw Error(response.statusText);
        responsejson = await response.json();
    }
    catch (err) {
        console.log(`error fetchData: ${err}`);
    }

    return setPerformance(responsejson)
}

export const getWeekDates = () => {
    let dates = [];
    for (let i = -1; i > -8; i--) {
        dates.push(moment().add(i, 'days').format(DBDateFormat));
    }
    return dates;
}

export const getMonthDates = () => {
    let dates = [];
    for (let i = -28; i < 0; i++) {
        dates.push(moment().add(i, 'days').format(DBDateFormat));
    }
    return dates;
}

export const getMonthRange = () => {
    let start = moment().add(-28, 'days').format(DateDisplayFormat);
    let end = moment().add(-1, 'days').format(DateDisplayFormat);

    return `${start} - ${end}`;
}

export const getYesterdayDate = () => {
    return moment().add(-1, 'days').format(DBDateFormat);
}

export const percentageColor = (percentage, preventConversion = false, asHex = false, hexAlpha = 1) => {
    if(percentage > 1 && !preventConversion)
        percentage = percentage / 100;
    let color = !asHex ? "green" : `rgba(0,165,0,${hexAlpha})`;
    if(percentage < 0.5)
        color = !asHex ? "red" : `rgba(255,0,0,${hexAlpha})`;
    if((percentage >= 0.5 && percentage < 0.7) || percentage > 1.5)
        color = !asHex ? "orange" : `rgba(255,165,0,${hexAlpha})`;
    return color;
}

export const arrayEqual = (value, other) => {
    const type = Object.prototype.toString.call(value);

    if (type !== Object.prototype.toString.call(other)) return false;
    if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;

    const valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
    const otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
    if (valueLen !== otherLen) return false;

    const compare = function (item1, item2) {
        const itemType = Object.prototype.toString.call(item1);
        if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
            if (!arrayEqual(item1, item2)) return false;
        } else {
            if (itemType !== Object.prototype.toString.call(item2)) return false;
            if (itemType === '[object Function]') {
                if (item1.toString() !== item2.toString()) return false;
            } else {
                if (item1 !== item2) return false;
            }

        }
    };

    if (type === '[object Array]') {
        for (let i = 0; i < valueLen; i++) {
            if (compare(value[i], other[i]) === false) return false;
        }
    } else {
        for (let key in value) {
            if (value.hasOwnProperty(key)) {
                if (compare(value[key], other[key]) === false) return false;
            }
        }
    }

    return true;

};



// WEBPACK FOOTER //
// ./src/util/util.js